import { Routes } from '@angular/router';
import { AccountCompletionGuard } from './shared/guards/accountCompletion.guard';
import { AuthEnabledGuard } from './shared/guards/auth-enabled.guard';
import { HomePageRedirectGuard } from './shared/guards/homepage-redirect/homepage-redirect.guard';

export const routes: Routes = [
  {
    path: ':lang/pages/:pageUrl',
    loadChildren: () =>
      import('./modules/additional-page-one').then(
        (m) => m.AdditionalPageOneView
      ),
    pathMatch: 'full',
    canActivate: [],
  },
  {
    path: ':lang/terms',
    loadChildren: () => import('./modules/terms').then((m) => m.TermsView),
    pathMatch: 'full',
    canActivate: [],
  },
  {
    path: ':lang/contact',
    loadChildren: () => import('./modules/contact').then((m) => m.ContactView),
    pathMatch: 'full',
    canActivate: [],
  },
  {
    path: ':lang/about-us',
    loadChildren: () => import('./modules/about-us').then((m) => m.AboutUsView),
    pathMatch: 'full',
    data: {
      title: 'About Us',
      description: 'This is the about us page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [],
  },
  {
    path: ':lang/sell-vehicle',
    loadChildren: () =>
      import('./pages/sell-vehicle').then((m) => m.SellVehicleView),
    data: {
      title: 'Sell a vehicle',
      description: 'This is the sell sa vehicle page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [],
  },
  {
    path: ':lang/not-found',
    loadChildren: () =>
      import('./shared/components/not-found').then((m) => m.NotFoundView),
    pathMatch: 'full',
    canActivate: [],
  },
  {
    path: ':lang/auctions-management',
    loadChildren: () =>
      import('./modules/auctions').then((m) => m.AuctionsView),
    pathMatch: 'full',
    canActivate: [],
  },
  {
    path: ':lang/for-sale/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      title: 'Machine Details Page',
      description: 'This is the machine description page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [],
  },
  {
    path: ':lang/for-sale',
    pathMatch: 'full',
    loadChildren: () => import('./pages/for-sale').then((m) => m.ForSaleView),
    data: {
      title: 'For Sale',
      description: 'This is the for sale page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [],
  },
  {
    path: ':lang/home',
    loadChildren: () =>
      import('./modules/homepage').then((m) => m.HomepageView),
    pathMatch: 'full',
    data: {
      title: 'Home Page',
      description: 'This is the home page',
      image: 'path/to/home-image.jpg',
    },
  },
  {
    path: ':lang/login',
    loadChildren: () => import('./pages/login').then((m) => m.LoginView),
    pathMatch: 'full',
    data: {
      title: 'Login',
      description: 'User login page.',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/register',
    loadChildren: () => import('./pages/register').then((m) => m.RegisterView),
    pathMatch: 'full',
    data: {
      title: 'Signup Page',
      description: 'This is the freemium user signup page',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/validate',
    loadChildren: () =>
      import('./pages/validate').then((m) => m.ValidateEmailView),
    pathMatch: 'full',
    data: {
      title: 'Validate Email',
      description: 'Validate user page.',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/private-portals',
    loadChildren: () =>
      import('./pages/private-portals').then((m) => m.PrivatePortalsView),
    pathMatch: 'full',
    data: {
      title: 'Private Portals',
      description: 'Private Portals List',
    },
    canActivate: [AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: ':lang/private-portals/:shortName',
    loadChildren: () =>
      import('./pages/private-portal-for-sale').then((m) => m.PrivatePortalsForSaleView),
    pathMatch: 'full',
    data: {
      title: 'Private Portal',
      description: 'Private Portal',
    },
    canActivate: [AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: ':lang/private-portals/:shortName/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      title: 'Machine Details Page',
      description: 'This is the machine description page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/homepage').then((m) => m.HomepageView),
    canActivate: [HomePageRedirectGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: () =>
      import('./shared/components/not-found').then((m) => m.NotFoundView),
  },
];
